import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import FilterTile from "./FilterTile";

type ActiveFiltersListProps = {
  activeFiltersEntries: [string, any][];
  activeFilter: string | null;
  availableFilters: Record<string, { data_type: string }>;
  onFilterClick: (filterKey: string) => void;
  onClear: (filterKey: string) => void;
  columnsTitleCreator?: (column: string) => string;
};

export default function ActiveFiltersList({
  activeFiltersEntries,
  activeFilter,
  availableFilters,
  onFilterClick,
  onClear,
  columnsTitleCreator,
}: ActiveFiltersListProps) {
  return (
    <div className="flex flex-col mt-3 mb-6">
      <h2 className="text-xs text-[#00000040] font-bold mb-2">
        <span>ACTIVE ({activeFiltersEntries?.length})</span>
      </h2>
      {activeFiltersEntries.length > 0 ? (
        <div className="flex flex-col gap-2">
          {activeFiltersEntries.map(([filterKey, values]) => (
            <div key={filterKey} className="flex items-center gap-2">
              <div className="w-[255px]">
                <FilterTile
                  filter={filterKey}
                  isSelected={activeFilter === filterKey}
                  dataType={availableFilters[filterKey]?.data_type as any}
                  hasFilterValues={true}
                  filterValue={values}
                  onClick={() => onFilterClick(filterKey)}
                  showGlowEffect={true}
                  columnsTitleCreator={columnsTitleCreator}
                />
              </div>
              <Button
                type="text"
                size="small"
                icon={<CloseOutlined />}
                /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-unused-vars */
                onClick={(e) => {
                  onClear(filterKey);
                }}
                className="text-[#00000073] p-1 w-6 h-6 flex items-center justify-center shrink-0"
              />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-[#00000073] text-sm">
          Filter something and it&apos;ll show up here.
        </p>
      )}
    </div>
  );
}
